module.exports = __webpack_public_path__ + "static/media/EAT_graphic.c93ef1a2.svg";